import React from 'react';
import { Download, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.shraddha.spiritualai';

const FinalCTA = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-orange-500/10 rounded-full blur-3xl cosmic-glow"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-serif text-4xl lg:text-6xl font-bold mb-6 text-white leading-tight">
            Whenever you feel lost, remember <span className="text-gradient">you are not alone</span>.
          </h2>
          
          <p className="text-xl lg:text-2xl text-gray-300 mb-10 leading-relaxed">
            Begin your spiritual journey today. Connect with divine wisdom anytime, anywhere.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer">
              <Button 
                className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-10 py-6 text-lg rounded-full glow-effect btn-primary"
                size="lg"
              >
                <Download className="w-5 h-5 mr-2" />
                Download the App
              </Button>
            </a>
            <Button 
              variant="outline" 
              className="border-2 border-orange-500/50 text-white hover:bg-orange-500/10 px-10 py-6 text-lg rounded-full backdrop-blur-sm"
              size="lg"
            >
              Start Your Spiritual Journey
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>

          <p className="text-gray-400 text-sm">
            Available on Android • Coming Soon on iOS
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;